<template>
  <Modal v-model="model" sticky reset-drag-position :title="title" @on-cancel="cancel" footer-hide :mask="false" draggable scrollable class="trigger-pop-style" width="800">
    <div class="input_single">
      <div class="font_style_set"><span style="color: #ed4014">*</span>名称:</div>
      <Input v-model="triggerName" class="input_content"  placeholder="请输入名称"/>
    </div>
    <div class="input_single">
      <div class="font_style_set">备注:</div>
      <Input v-model="triggerDescribe" class="input_content" type="textarea"  placeholder="请输入备注"/>
    </div>
    <div class="contain-style">
    <div class="condition-style">
      <b>符合下列<span style="color: #ed4014">所有</span>条件</b><Icon type="md-add-circle" color="#57a3f3" size="25" style="float: right;margin-right:16px" @click="addAll()"/>

        <div class="condition-select-style" v-for="(itemCondition,index) in allCondition">
          <Select placeholder="请选择" style="width:35%" @on-select ="((val)=>{allSelect(index,val)})" v-model="itemCondition.customColName"  filterable>
              <Option v-for="item in allConditionList" :value="item.customColName" :key="item.customColName">{{ item.customName }}</Option>
          </Select>
          <Select placeholder="请选择" style="width:20%" :value="itemCondition.filterList[0].value" @on-select ="((val)=>{filterSelect(index,val,'all')})">
              <Option v-for="item in allFilterMap.get(itemCondition.customColName)" :value="item.value" :key="item.value">{{ item.key }}</Option>
          </Select>
          <!-- 最右边 -->
          <Select placeholder="请选择" :ref="'allIndex'+index" style="width:35%" v-if="(allFieldMap.get(itemCondition.customColName) == 'select' || allFieldMap.get(itemCondition.customColName) == 'radio') && itemCondition.customColName && itemCondition.customColName != 'orderHandler'" v-model="itemCondition.list" filterable :filter-by-label = "true">
              <Option v-for="item in allListMap.get(itemCondition.customColName)" :disabled="item.isClose == '0'" :value="item.id" :key="item.id">{{  itemCondition.customColName == 'serviceGroup' ? item.groupName:item.dictValue }}</Option>
          </Select>
          <!-- 处理人select分组 -->
          <Select placeholder="请选择" style="width:35%" :ref="'allIndex'+index" v-else-if="itemCondition.customColName == 'orderHandler'" v-model="itemCondition.list" :filter-by-label = "true" filterable>
              <OptionGroup label="员工">
                <Option v-for="item in allListMap.get(itemCondition.customColName)" :value="item.id" :key="item.id">{{item.dictValue }}</Option>
              </OptionGroup>
              <OptionGroup label="服务组">
                <Option v-for="item in allListMap.get(itemCondition.customColName+'_group')" :value="item.id" :key="item.id">{{item.groupName }}</Option>
              </OptionGroup>
          </Select>

          <Select placeholder="请选择" style="width:35%" multiple v-else-if="allFieldMap.get(itemCondition.customColName) == 'checkbox'" @on-open-change="((val)=>{allOpenChange(index,val)})" :max-tag-count="1" v-model="itemCondition.list" filterable>
              <Option v-for="item in allListMap.get(itemCondition.customColName)" :value="item.id" :key="item.id">{{item.dictValue }}</Option>
          </Select>
          <DatePicker type="datetime" placeholder="请选择日期时间" style="width:35%" v-else-if="allFieldMap.get(itemCondition.customColName) == 'datetime'" format="yyyy-MM-dd HH:mm:ss" v-model="itemCondition.list"/>

          <!-- 时长数字框-->
          <div v-else-if="allFieldMap.get(itemCondition.customColName) == 'duration'" class="duration-style">
            <Input type="number" placeholder="请输入" style="width:35%" @on-change="durationDataChange(index)" v-model="itemCondition.day < 0 ? 0 : itemCondition.day"><span slot="append">天</span></Input>
            <Input type="number" placeholder="请输入" style="width:35%" @on-change="durationDataChange(index)" v-model="itemCondition.hour < 0 ? 0 : itemCondition.hour"><span slot="append">时</span></Input>
            <Input type="number" placeholder="请输入" style="width:35%" @on-change="durationDataChange(index)" v-model="itemCondition.min < 0 ? 0 : itemCondition.min"><span slot="append">分</span></Input>
            <Input type="number" placeholder="请输入" style="width:35%" v-show="false" v-model="itemCondition.list"></Input>
          </div>
          <!-- 普通数字框-->
          <InputNumber :step="1" :min="1" placeholder="请输入" style="width:35%" v-else-if="allFieldMap.get(itemCondition.customColName) == 'number'" v-model="itemCondition.list"/>
          <Input type="textarea" :rows="1" placeholder="请输入" style="width:35%;" v-else-if="allFieldMap.get(itemCondition.customColName) == 'textarea'" v-model="itemCondition.list"/>
          <el-cascader clearable style="width:35%;" v-else-if="allFieldMap.get(itemCondition.customColName) == 'cascade'" v-model="itemCondition.list" placeholder="请选择" :options="allListMap.get(itemCondition.customColName)" :props="{ expandTrigger: 'hover' }"></el-cascader>
          <Input placeholder="请输入" style="width:35%" v-else v-model="itemCondition.list"/>
          <Icon type="md-remove-circle" color="red" size="25" @click="delAll(index)"/>
        </div>
    </div>
    <b style="margin: 10px;">并且</b>
    <div class="condition-style">
      <b>符合下列<span style="color: #ed4014">任何</span>条件</b><Icon type="md-add-circle" color="#57a3f3" size="25" style="float: right;margin-right:16px" @click="addAny()"/>
      <div class="condition-select-style" v-for="(itemCondition,index) in anyCondition">
         <Select placeholder="请选择" style="width:35%" @on-select ="((val)=>{anySelect(index,val)})" v-model="itemCondition.customColName" filterable>
              <Option v-for="item in anyConditionList" :value="item.customColName" :key="item.customColName">{{ item.customName }}</Option>
          </Select>
          <Select placeholder="请选择" style="width:20%" :value="itemCondition.filterList[0].value" @on-select ="((val)=>{filterSelect(index,val,'any')})" filterable>
              <Option v-for="item in anyFilterMap.get(itemCondition.customColName)" :value="item.value" :key="item.key">{{ item.key }}</Option>
          </Select>

          <Select placeholder="请选择" style="width:35%" :ref="'anyIndex'+index" v-if="(anyFieldMap.get(itemCondition.customColName) == 'select' || anyFieldMap.get(itemCondition.customColName) == 'radio')  && itemCondition.customColName && itemCondition.customColName != 'orderHandler'" v-model="itemCondition.list" filterable :filter-by-label = "true">
              <Option v-for="item in anyListMap.get(itemCondition.customColName)" :disabled="item.isClose == '0'" :value="item.id" :key="item.id">{{ itemCondition.customColName == 'serviceGroup' ? item.groupName:item.dictValue }}</Option>
          </Select>
          <!-- 处理人select分组 -->
          <Select placeholder="请选择" style="width:35%" :ref="'anyIndex'+index" v-else-if="itemCondition.customColName == 'orderHandler'" v-model="itemCondition.list" filterable>
              <OptionGroup label="员工">
                <Option v-for="item in anyListMap.get(itemCondition.customColName)" :value="item.id" :key="item.id">{{item.dictValue }}</Option>
              </OptionGroup>
              <OptionGroup label="服务组">
                <Option v-for="item in anyListMap.get(itemCondition.customColName+'_group')" :value="item.id" :key="item.id">{{item.groupName }}</Option>
              </OptionGroup>
          </Select>

          <Select placeholder="请选择" style="width:35%" multiple v-else-if="anyFieldMap.get(itemCondition.customColName) == 'checkbox'" @on-open-change="((val)=>{anyOpenChange(index,val)})" :max-tag-count="1" v-model="itemCondition.list" filterable :filter-by-label = "true">
              <Option v-for="item in anyListMap.get(itemCondition.customColName)" :value="item.id" :key="item.id">{{ item.dictValue }}</Option>
          </Select>
          <DatePicker type="datetime" placeholder="请选择日期时间" style="width:35%" v-else-if="anyFieldMap.get(itemCondition.customColName) == 'datetime'" format="yyyy-MM-dd HH:mm:ss" v-model="itemCondition.list"/>
          <InputNumber :step="1" :min="1" placeholder="请输入" style="width:35%" v-else-if="anyFieldMap.get(itemCondition.customColName) == 'number'" v-model="itemCondition.list"/>
          <Input type="textarea" :rows="1" placeholder="请输入" style="width:35%;" v-else-if="anyFieldMap.get(itemCondition.customColName) == 'textarea'" v-model="itemCondition.list"/>
          <el-cascader clearable style="width:35%;" v-else-if="anyFieldMap.get(itemCondition.customColName) == 'cascade'" v-model="itemCondition.list" placeholder="请选择" :options="anyListMap.get(itemCondition.customColName)" :props="{ expandTrigger: 'hover' }"></el-cascader>

          <Input placeholder="请输入" style="width:35%" v-else v-model="itemCondition.list"/>
         <Icon type="md-remove-circle" color="red" size="25" @click="delAny(index)"/>
      </div>
    </div>
    <b style="margin: 10px;">则</b>
    <div class="condition-style">
      <b>执行以下操作</b><Icon type="md-add-circle" color="#57a3f3" size="25" style="float: right;margin-right:16px" @click="addOperate()"/>
      <div v-for="(itemCondition,index) in executeCondition">
         <div class="condition-select-style" v-if="itemCondition.customIsSystem != '3' || itemCondition.customColName == 'copyEmpId'">
            <Select placeholder="请选择" style="width:46%" @on-select ="((val)=>{executeSelect(index,val)})" v-model="itemCondition.customColName" filterable>
                <Option v-for="item in executeConditionList.filter(cond => !executeSelectedField.has(cond.customColName) || executeSelectedField.get(cond.customColName) == index.toString())" :value="item.customColName" :key="item.customColName">{{ item.customName }}</Option>
            </Select>

            <!-- customIsSystem= 3表示特殊处理的字段 -->
            <Select placeholder="请选择" style="width:46%" :ref="'doIndex'+index" v-if="(executeFieldMap.get(itemCondition.customColName) == 'select' || executeFieldMap.get(itemCondition.customColName) == 'radio') && itemCondition.customColName && itemCondition.customColName != 'orderHandler'" v-model="itemCondition.list" filterable :filter-by-label = "true">
                <Option v-for="item in executeListMap.get(itemCondition.customColName)" :disabled="item.isClose == '0'" :value="item.id" :key="item.id">{{ itemCondition.customColName == 'serviceGroup' ? item.groupName:item.dictValue }}</Option>
            </Select>
            <Select placeholder="请选择" style="width:46%" multiple v-else-if="executeFieldMap.get(itemCondition.customColName) == 'checkbox'  && itemCondition.customColName && itemCondition.customColName != 'copyEmpId'" @on-open-change="((val)=>{executeOpenChange(index,val)})" :max-tag-count="1" v-model="itemCondition.list" filterable>
                <Option v-for="item in executeListMap.get(itemCondition.customColName)" :value="item.id" :key="item.id">{{ item.dictValue }}</Option>
            </Select>
            <el-cascader clearable style="width:46%;" v-else-if="executeFieldMap.get(itemCondition.customColName) == 'cascade'" v-model="itemCondition.list" placeholder="请选择" :options="executeListMap.get(itemCondition.customColName)" :props="{ expandTrigger: 'hover' }"></el-cascader>

            <!-- 处理人\抄送人select分组 -->
          <Select placeholder="请选择" style="width:46%" :ref="'doIndex'+index" v-else-if="itemCondition.customColName == 'orderHandler' || itemCondition.customColName == 'copyEmpId'" v-model="itemCondition.list" :max-tag-count="1" :multiple="itemCondition.customColName == 'copyEmpId'" filterable>
              <OptionGroup label="员工">
                <Option v-for="item in executeListMap.get(itemCondition.customColName)" :value="item.id" :key="item.id">{{item.dictValue }}</Option>
              </OptionGroup>
              <OptionGroup label="服务组">
                <Option v-for="item in executeListMap.get(itemCondition.customColName+'_group')" :value="item.id" :key="item.id">{{item.groupName }}</Option>
              </OptionGroup>
          </Select>

            <DatePicker type="datetime" placeholder="请选择日期时间" style="width:46%" v-else-if="executeFieldMap.get(itemCondition.customColName) == 'datetime'" format="yyyy-MM-dd HH:mm:ss" v-model="itemCondition.list"/>
            <InputNumber :step="1" :min="1" placeholder="请输入" style="width:46%" v-else-if="executeFieldMap.get(itemCondition.customColName) == 'number'" v-model="itemCondition.list"/>
            <Input type="textarea" :rows="1" placeholder="请输入" style="width:46%;" v-else-if="executeFieldMap.get(itemCondition.customColName) == 'textarea'" v-model="itemCondition.list"/>
            <Input placeholder="请输入" style="width:46%" v-else v-model="itemCondition.list"/>
            <Icon type="md-remove-circle" color="red" size="25" @click="delOperate(index,itemCondition.customColName)"/>
        </div>
          <!-- 回复 -->
          <div class="replay-style" v-if="itemCondition.customIsSystem == '3' && itemCondition.customColName == 'doReplay'">
            <Select placeholder="请选择" style="width:46%;margin-right:10px;margin-bottom:10px;" @on-select ="((val)=>{executeSelect(index,val)})" v-model="itemCondition.customColName" filterable>
                <Option v-for="item in executeConditionList" :value="item.customColName" :key="item.customColName">{{ item.customName }}</Option>
            </Select>

            <Select placeholder="请选择" style="width:46%;margin-bottom:10px;" v-model="replayType" @on-select ="((val)=>{replayTypeSelect(index,val)})">
                <Option value="0">公开</Option>
                <Option value="1">私密</Option>
            </Select>
            <Icon type="md-remove-circle" color="red" size="25" style="margin-left: 8px;" @click="delOperate(index,itemCondition.customColName)"/>
            <!-- 工单当前处理人、指定客服 -->
            <Select placeholder="请选择" style="width:46%;margin-right:10px;" v-model="itemCondition.filterList[0].value" @on-select="((val)=>{appointAgentSelect(index,val)})">
                <Option value="0">工单当前处理人</Option>
                <Option value="1">指定客服</Option>
            </Select>

            <Select placeholder="请选择" style="width:46%;" v-if="appointAgentFlag" v-model="itemCondition.replayEmployee" filterable :filter-by-label = "true" @on-select ="((val)=>{employeeSelect(index,val)})">
                <Option v-for="item in executeListMap.get(itemCondition.customColName)" :value="item.id" :key="item.id">{{ item.dictValue }}</Option>
            </Select>
            <Input placeholder="请输入回复内容" type="textarea" :rows="3" v-model="itemCondition.list" style="margin-top:10px;"/>
          </div>
            <!-- 删除工单 -->
            <div class="replay-style" v-if="itemCondition.customIsSystem == '3' && itemCondition.customColName == 'doDelete'">
              <Select placeholder="请选择" style="width:46%;margin-right:10px;" @on-select ="((val)=>{executeSelect(index,val)})" v-model="itemCondition.customColName" filterable>
                  <Option v-for="item in executeConditionList" :value="item.customColName" :key="item.customColName">{{ item.customName }}</Option>
              </Select>
              <Select placeholder="请选择" style="width:46%;" v-model="itemCondition.list" @on-select ="((val)=>{deleteSelect(index,val)})">
                  <Option v-for="item in executeListMap.get(itemCondition.customColName)" :value="item.dictValue" :key="item.id">{{ item.dictValue }}</Option>
              </Select>
              <Icon type="md-remove-circle" color="red" size="25" style="margin-left: 8px;" @click="delOperate(index,itemCondition.customColName)"/>
              <Input v-if="itemCondition.list == '其他原因'" style="margin-top:10px;" type="textarea" :rows="3" placeholder="请输入删除原因" v-model="itemCondition.reason"/>

            </div>
            <div class="condition-select-style" v-if="itemCondition.customColName == 'doNotice'  && itemCondition.customIsSystem == '3'">
              <!-- 通知 -->
              <Select placeholder="请选择" style="width:32%" @on-select ="((val)=>{executeSelect(index,val)})" v-model="itemCondition.customColName" filterable>
                  <Option v-for="item in executeConditionList" :value="item.customColName" :key="item.customColName">{{ item.customName }}</Option>
              </Select>
              <Select placeholder="请选择" style="width:25%" v-model="itemCondition.filterList[0].value" multiple filterable @on-open-change="((val)=>{executeOpenChange(index,val)})"  :max-tag-count="1">
                <Option v-for="item in executeFilterMap.get(itemCondition.customColName)" :value="item.value" :key="item.key">{{ item.key }}</Option>
              </Select>
              <Select placeholder="请选择" style="width:35%" multiple filterable v-model="itemCondition.rangesList" @on-change= "((val)=>{rangeSelect(index,val)})" :max-tag-count="1">
                <OptionGroup label="人员范围">
                    <Option v-for="item in executeListMap.get(itemCondition.customColName).ranges" :value="item.id+''" :key="item.id">{{ item.dictValue }}</Option>
                </OptionGroup>
                <OptionGroup label="指定服务组">
                    <Option v-for="item in executeListMap.get(itemCondition.customColName).orderGroupList" :value="'group_'+item.id" :key="item.id">{{ item.groupName }}</Option>
                </OptionGroup>
                <OptionGroup label="指定员工">
                    <Option v-for="item in executeListMap.get(itemCondition.customColName).empList" :value="'emp_'+item.id" :key="item.id">{{ item.dictValue }}</Option>
                </OptionGroup>
              </Select>
              <Icon type="md-remove-circle" color="red" size="25" @click="delOperate(index,itemCondition.customColName)"/>
          </div>


      </div>
    </div>
    </div>
    <div class="btn_template">
      <Button type="error"   class="cancel_btn" @click="cancel()">取消</Button>
      <Button type="primary" class="submit_btn" @click="save()" :loading="loading">保存</Button>
    </div>
  </Modal>
</template>

<script>
    export default {
      name: "FlowTriggerPop",
      props:{
          showPop:Boolean,
          triggerId:String
      },
      data(){
        return{
          model:false,
          title:"添加触发器",
          triggerName:'',
          triggerDescribe:'',
          id:'',
          menuId:'3_d-3-1',
          allCondition:[],
          anyCondition:[],
          executeCondition:[],

          allConditionList:[],//所有条件的选择
          allFilterMap: new Map(),//所有条件的判断选择
          allListMap: new Map(),//所有条件的判断选择
          allFieldMap: new Map(),//所有条件的文本类型

          anyConditionList:[],//任何条件的选择
          anyFilterMap: new Map(),//任何条件的判断选择
          anyListMap: new Map(),//任何条件的判断选择
          anyFieldMap: new Map(),//任何条件的文本类型

          executeConditionList:[],//执行动作的选择
          executeListMap: new Map(),//执行动作的判断选择
          executeFilterMap: new Map(),//执行动作的过滤条件选择
          executeFieldMap: new Map(),//执行动作的文本类型

          deleteReasonFlag:false, //删除工单其他原因标识
          deleteReason: '', //删除工单其他原因内容

          replayType: '0', //回复类型，默认公开

          appointAgentFlag: false, //指定客服标识
          executeSelectedField: new Map(), //执行动作已经选择的字段
          loading:false,
        }
      },
      methods:{
        cancel:function () {
          this.allCondition.length = 0;
          this.anyCondition.length = 0;
          this.executeCondition.length = 0;
          this.triggerName = '';
          this.triggerDescribe ='';
          this.executeSelectedField.clear();
          this.$emit("closeTriggerPop",false)
        },
        allSelect:function(index,selectObj){
          let newValue = 'allIndex'+index;
          if(this.$refs[newValue] && this.$refs[newValue][0]){
            this.$refs[newValue][0].setQuery(' ');
          }
          let value = selectObj.value;
          let allObj = this.allConditionList.find(item => item.customColName === value);

          // 中间的过滤
          if(allObj.filterList) this.allFilterMap.set(value, JSON.parse(JSON.stringify(allObj.filterList)));
          // 字段类型
          this.allFieldMap.set(value, allObj.customType);
          // 字段值
          if(allObj.list) this.allListMap.set(value, JSON.parse(JSON.stringify(allObj.list)));
          // 如果是处理人或抄送人，选择时包含服务组
          if(value == 'orderHandler' || value == 'copyEmpId'){
            if(allObj.orderGroupList) this.allListMap.set(value+'_group',JSON.parse(JSON.stringify(allObj.orderGroupList)));
          }
          // 将选择的类型更新到数据上
          this.allCondition[index].customType = allObj.customType;
          this.allCondition[index].customIsSystem = allObj.customIsSystem;
          this.allCondition[index].customColSource = allObj.customColSource;
          this.allCondition[index].customColName = allObj.customColName;
          // 时长类的单独处理
          if(allObj.customType == 'duration'){

            this.allCondition[index]['day'] = 0;

            this.allCondition[index]['hour'] = 0;

            this.allCondition[index]['min'] = 0;

          } else if("number" == allObj.customType){
            this.allCondition[index].list = this.allCondition[index].list == "" ? 1 : this.allCondition[index].list;
          }
          // 切换后，将上次数据清除
          this.allCondition[index].filterList[0] = allObj.filterList[0];
          this.allCondition[index].list = "";

        },
        anySelect:function(index,selectObj){
          let newValue = 'anyIndex'+index;
          if(this.$refs[newValue] && this.$refs[newValue][0]){
            this.$refs[newValue][0].setQuery(' ');
          }
          let value = selectObj.value;
          let anyObj = this.anyConditionList.find(item => item.customColName === value);

          if(anyObj.filterList) this.anyFilterMap.set(value, JSON.parse(JSON.stringify(anyObj.filterList)));
          this.anyFieldMap.set(value, anyObj.customType);
          if(anyObj.list) this.anyListMap.set(value, JSON.parse(JSON.stringify(anyObj.list)));
          // 如果是处理人或抄送人，选择时包含服务组
          if(value == 'orderHandler' || value == 'copyEmpId'){
            if(anyObj.orderGroupList) this.anyListMap.set(value+'_group',JSON.parse(JSON.stringify(anyObj.orderGroupList)));
          }
          // 将选择的类型更新到数据上
          this.anyCondition[index].customType = anyObj.customType;
          this.anyCondition[index].customIsSystem = anyObj.customIsSystem;
          this.anyCondition[index].customColSource = anyObj.customColSource;

          // 切换后，将上次数据清除
          this.anyCondition[index].filterList[0] = anyObj.filterList[0];
          this.anyCondition[index].list = "";
        },
        executeSelect:function(index,selectObj){
          let newValue = 'doIndex'+index;
          if(this.$refs[newValue] && this.$refs[newValue][0]){
            this.$refs[newValue][0].setQuery(' ');
          }
          let value = selectObj.value;
          let executeObj = this.executeConditionList.find(item => item.customColName === value);

          if(executeObj.filterList) this.executeFilterMap.set(value, JSON.parse(JSON.stringify(executeObj.filterList)));

          this.executeFieldMap.set(value, executeObj.customType);
          if(executeObj.list) this.executeListMap.set(value, JSON.parse(JSON.stringify(executeObj.list)));
          // 如果是处理人或抄送人，选择时包含服务组
          if(value == 'orderHandler' || value == 'copyEmpId'){
            if(executeObj.orderGroupList) this.executeListMap.set(value+'_group',JSON.parse(JSON.stringify(executeObj.orderGroupList)));
          }
          // 将选择的类型更新到数据上
          this.executeCondition[index].customType = executeObj.customType;
          this.executeCondition[index].customIsSystem = executeObj.customIsSystem;
          this.executeCondition[index].customColSource = executeObj.customColSource;
          this.executeCondition[index].customColName = executeObj.customColName;
          if("doReplay"== executeObj.customColName){
            this.executeCondition[index]["replayType"] = '0';
            this.executeCondition[index].filterList[0].value = '0';
            this.executeCondition[index].replayEmployee = '';
            this.executeCondition[index].list = "";
          }
          if("doNotice"== executeObj.customColName){
            this.executeCondition[index].filterList[0].value = '';
            this.executeCondition[index].list = {empList:[],orderGroupList:[],ranges:[]};
            this.executeCondition[index]['rangesList'] = '';
            this.appointAgentFlag = false;
          }
          if("doDelete"== executeObj.customColName){
            this.executeCondition[index].list = executeObj.list[0].dictValue;
            this.executeCondition[index]['reason'] = '';
          }
          // 先将之前选中的从executeSelectedField中删除，再添加
          for (let [key, value] of this.executeSelectedField) {
            if(value == index.toString()){
              this.executeSelectedField.delete(key);
            }
          }
          this.executeSelectedField.set(executeObj.customColName,index.toString());
          // 切换后，将上次数据清除
          if("doNotice"!= executeObj.customColName && "doReply"!= executeObj.customColName && "doDelete" != executeObj.customColName){  //通知 需要的数据格式不一样
            this.executeCondition[index].filterList[0] = executeObj.filterList[0];
            this.executeCondition[index].list = "";
          }
        },
        init:function(){
          let param = {
            id : this.id,
          }
          let that = this;
          this.$http.post("trigger/toIndex.json",param) .then(function (res) {
                let result=res.data.flag;
                if(result!="666"){
                  that.$Message.error(res.data.msg);
                  return false;
                }
                that.allConditionList = res.data.obj.allConditionList;
                that.anyConditionList = res.data.obj.anyConditionList;
                that.executeConditionList = res.data.obj.executeActionList;
                if(that.id && that.id != "-1"){ //编辑的数据
                  that.triggerName = res.data.obj.list.content[0].triggerName;
                  that.triggerDescribe = res.data.obj.list.content[0].triggerDescribe;
                  that.allCondition = JSON.parse(res.data.obj.list.content[0].allCondition);
                  that.anyCondition = JSON.parse(res.data.obj.list.content[0].anyCondition);
                  that.executeCondition = JSON.parse(res.data.obj.list.content[0].executeAction);
                  // 对条件中填充数据
                  for(let i = 0; i < that.allCondition.length; i++){
                    that.allSelectPop(i,{value:that.allCondition[i].customColName});
                  }
                  for(let i = 0; i < that.anyCondition.length; i++){
                    that.anySelectPop(i,{value:that.anyCondition[i].customColName});
                  }
                  for(let i = 0; i < that.executeCondition.length; i++){
                    that.executeSelectPop(i,that.executeCondition[i]);
                  }
                }else{
                  
                  that.allConditionList.forEach(item =>{
                    if(item.customIsSystem == '1' && (item.customType == 'select' || item.customType == 'radio' || item.customType == 'checkbox')){
                      item.list = item.list.filter(option => option.isClose != '0');
                    }
                  });
                  that.anyConditionList.forEach(item =>{
                    if(item.customIsSystem == '1' && (item.customType == 'select' || item.customType == 'radio' || item.customType == 'checkbox')){
                      item.list = item.list.filter(option => option.isClose != '0');
                    }
                  });
                  that.executeConditionList.forEach(item =>{
                    if(item.customIsSystem == '1' && (item.customType == 'select' || item.customType == 'radio' || item.customType == 'checkbox')){
                      item.list = item.list.filter(option => option.isClose != '0');
                    }
                  });

                  that.triggerName = "";
                  that.triggerDescribe = "";
                  that.allCondition = [];
                  that.anyCondition = [];
                  that.executeCondition = [];
                }
              })
        },
        save:function () {
          let that=this;
          if (!this.triggerName){
            this.$Message.error("触发器名称不能为空");
            return false;
          }
          // 数据为空判断和数据格式化分开，是因为数据格式化后就不能正确显示，而出现错误提示后，不能再将此还原，所以先判断是否为空，再将数据格式化
          // 判断数据不能为空
          //判断通知方式不能为空,用for循环而不用forEach是因为在forEach中，return不能暂停，而会一直执行下去
          let item = '';
          // 全部条件
          for(let i = 0; i < this.allCondition.length; i++){
            item = this.allCondition[i];
            if(item.customType == 'cascade'){
              if(item.list.length == 0){
                  this.$Message.error("所有条件中数据值不能为空");
                  return;
              }
            }else if(!item.list){
              this.$Message.error("所有条件中数据值不能为空");
              return;
            }

          }
          // 任何条件
          for(let i = 0; i < this.anyCondition.length; i++){
            item = this.anyCondition[i];
            if(item.customType == 'cascade'){
              if(item.list.length == 0){
                this.$Message.error("任何条件中数据值不能为空");
                return;
              }
            }else if(!item.list){
              this.$Message.error("任何条件中数据值不能为空");
              return;
            }

          }
          // 执行动作
          for(let i = 0; i < this.executeCondition.length; i++){
            item = this.executeCondition[i];

            if(item.customColName == 'doReplay'){
              if(!item.list){
                this.$Message.error("执行操作中回复内容不能为空");
                return;
              }
            }else if(item.customColName == 'doNotice'){
              if(item.filterList[0].value.length == 0){
                this.$Message.error("执行操作中通知方式不能为空");
                return;
              }
              if(item.list.empList.length == 0 && item.list.orderGroupList.length == 0 && item.list.ranges.length == 0){
                this.$Message.error("执行操作中通知范围不能为空");
                return;
              }
            }else if(item.customColName == 'doDelete'){

              if("其他原因" == item.list){
                if(!item.reason){
                  this.$Message.error("执行操作中删除原因不能为空");
                  return;
                }
              }

            }else if(item.customType == 'checkbox'){
              if(item.list.length == 0){
                this.$Message.error("执行操作中数据值不能为空");
                return;
              }
            }else if(item.customType == 'cascade'){
              if(item.list.length == 0){
                this.$Message.error("执行操作中数据值不能为空");
                return;
              }
            }else if(!item.list){
              this.$Message.error("执行操作中数据值不能为空");
              return;
            }
          }

          // 对数据进行格式化
          this.allCondition.forEach(item =>{
            if(item.customType == 'datetime'){
              item.list = this.changeDate(item.list);
            }else if(item.customType == 'checkbox' || item.customType == 'cascade'){
              item.list = item.list.toString();
            }
          });
          this.anyCondition.forEach(item =>{

            if(item.customType == 'datetime'){
              item.list = this.changeDate(item.list);
            }else if(item.customType == 'checkbox' || item.customType == 'cascade'){
              item.list = item.list.toString();
            }
          });

          this.executeCondition.forEach(item =>{
            if(item.customType == 'datetime'){
              item.list = this.changeDate(item.list);
            }else if((item.customType == 'checkbox' || item.customType == 'cascade') && item.customColName != 'doNotice'){
              item.list = item.list.toString();
            }
          });
          this.loading = true;
          let param={
            id: this.id,
            triggerName:this.triggerName,
            triggerDescribe:this.triggerDescribe,
            allConditionList: JSON.stringify(this.allCondition),
            anyConditionList:JSON.stringify(this.anyCondition),
            executeActionList:JSON.stringify(this.executeCondition),
            journalType:"工单配置=>流程触发器=>"+this.title,
            menuId:this.menuId
          };
          this.$http.post("trigger/doSave.json",param) .then(function (res) {
            let result=res.data.flag;
            that.loading = false;
            if(result!="666"){
              that.$Message.error(res.data.msg);
              return false;
            }
            that.$Message.success("操作成功");

            that.allCondition.length = 0;
            that.anyCondition.length = 0;
            that.executeCondition.length = 0;
            that.triggerName = '';
            that.triggerDescribe ='';
            that.executeSelectedField.clear();
            that.$emit("closeTriggerPop",true)
          })
        },
        // 添加全部条件
        addAll:function(){
            this.allCondition.push({customType:"",customColName:"",customIsSystem:"",customColSource:"",filterList:[{"key":"","value":""}],list:""});
        },
        delAll: function(index){
            this.allCondition.splice(index, 1);
        },
        // 添加任何条件
        addAny:function(){
            this.anyCondition.push({customType:"",customColName:"",customIsSystem:"",customColSource:"",filterList:[{"key":"","value":""}],list:""});
        },
        delAny: function(index){
            this.anyCondition.splice(index, 1);

        },
        // 添加执行操作
        addOperate:function(){
            this.executeCondition.push({customType:"text",customColName:"",customIsSystem:"1",customColSource:"",filterList:[{"key":"","value":""}],list:""});
        },
        delOperate: function(index,customColName){
          this.executeCondition.splice(index,1);
          // 先清除已经选择的字段，再重新将已存在的字段set，这样是为了删除之后，导致顺序不一致，后面的数据都是空
          this.executeSelectedField.clear();

          for(let i = 0; i < this.executeCondition.length; i++){
            if(this.executeCondition[i].customColName){
              this.executeSelectedField.set(this.executeCondition[i].customColName,i.toString());
            }
          }
        },
        // 删除原因选项变化
        deleteSelect:function(index,selectObj){
            if("其他原因" != selectObj.value){
              this.executeCondition[index].reason = '';
            }
        },
        // 回复事件中，指定客服选择事件
        appointAgentSelect:function(index,selectObj){
          if(selectObj.value == '0'){ //工单当前处理人
            this.appointAgentFlag = false;
          }else{ //指定客服
            this.appointAgentFlag = true;
          }
          this.executeCondition[index].filterList[0].value = selectObj.value;
        },
        // 回复事件中，回复的类型选择
        replayTypeSelect: function(index,selectObj){
          this.executeCondition[index]["replayType"] = selectObj.value;
        },
        // 回复事件中，指定客服选中的值
        employeeSelect: function(index,selectObj){
          this.executeCondition[index]["replayEmployee"] = selectObj.value;
        },
        // 通知，人员范围选择
        rangeSelect: function(index, selectObj){
          this.executeCondition[index].list.empList.length = 0;
          this.executeCondition[index].list.orderGroupList.length = 0;
          this.executeCondition[index].list['ranges'].length = 0;
          selectObj.forEach(value => {
            if(value.indexOf('emp_') > -1){
              this.executeCondition[index].list['empList'].push(value.replace('emp_',''));
            }else if(value.indexOf('group_') > -1){
              this.executeCondition[index].list['orderGroupList'].push(value.replace('group_',''));
            }else {
              this.executeCondition[index].list['ranges'].push(value);
            }
          });

        },
        // 数据回显需要处理的事件   执行条件
        executeSelectPop:function(index,selectObj){
          let value = selectObj.customColName;

          let executeObj = this.executeConditionList.find(item => item.customColName === value);

          if(executeObj.filterList) this.executeFilterMap.set(value, JSON.parse(JSON.stringify(executeObj.filterList)));

          this.executeFieldMap.set(value, executeObj.customType);
          if(executeObj.list) this.executeListMap.set(value, JSON.parse(JSON.stringify(this.doColseField(executeObj,this.executeCondition[index].list))));
          this.executeCondition[index].customColName = executeObj.customColName;
          // 将选择的类型更新到数据上
          if("copyEmpId"== executeObj.customColName || "orderHandler"== executeObj.customColName){
            if(executeObj.orderGroupList) this.executeListMap.set(value+'_group', JSON.parse(JSON.stringify(executeObj.orderGroupList)));
          }
          if("doReplay"== executeObj.customColName){
            this.executeCondition[index]["replayType"] = selectObj.replayType;
            this.executeCondition[index]["replayEmployee"] = selectObj.replayEmployee;
            this.appointAgentSelect(index,{value:selectObj.filterList[0].value});
          }else if("doNotice"== executeObj.customColName){
            let data = [];
            if(this.executeCondition[index].list.ranges){
              this.executeCondition[index].list.ranges.forEach(item =>{
                data.push(item);
              });
            }
            if(this.executeCondition[index].list.orderGroupList){
              this.executeCondition[index].list.orderGroupList.forEach(item =>{
                data.push('group_'+item);
              });
            }
            if(this.executeCondition[index].list.empList){
              this.executeCondition[index].list.empList.forEach(item =>{
                data.push('emp_'+item);
              });
            }
            this.executeCondition[index].rangesList = data;
          }else if("doDelete"== executeObj.customColName){
          }else if("checkbox" == executeObj.customType || "cascade" == executeObj.customType){
            this.executeCondition[index].list = this.executeCondition[index].list.split(',');
          }
          // 先将之前选中的从executeSelectedField中删除，再添加
          for (let [key, value] of this.executeSelectedField) {
            if(value == index.toString()){
              this.executeSelectedField.delete(key);
            }
          }
          this.executeSelectedField.set(executeObj.customColName,index.toString());
        },
        // 数据回显  所有条件
        allSelectPop:function(index,selectObj){
          let value = selectObj.value;
          let allObj = this.allConditionList.find(item => item.customColName === value);

          // 中间的过滤
          if(allObj.filterList) this.allFilterMap.set(value, JSON.parse(JSON.stringify(allObj.filterList)));
          // 字段类型
          this.allFieldMap.set(value, allObj.customType);
          // 字段值
          if(allObj.list) this.allListMap.set(value, JSON.parse(JSON.stringify(this.doColseField(allObj,this.allCondition[index].list))));
          // 如果是处理人或抄送人，将服务组
          if(value == 'orderHandler' || value == 'copyEmpId'){
            if(allObj.orderGroupList) this.allListMap.set(value+'_group', JSON.parse(JSON.stringify(allObj.orderGroupList)));
          }
          // 将选择的类型更新到数据上
          this.allCondition[index].customType = allObj.customType;
          this.allCondition[index].customIsSystem = allObj.customIsSystem;
          this.allCondition[index].customColSource = allObj.customColSource;
          this.allCondition[index].customColName = allObj.customColName;
          // 时长类的单独处理
          if(allObj.customType == 'duration'){
              if(this.allCondition[index].list){
                let day = parseInt(parseInt(this.allCondition[index].list) / (60 * 24));
                this.allCondition[index]['day'] = day;

              let hour = parseInt((parseInt(this.allCondition[index].list) - (day * 24 * 60)) / 60);

                this.allCondition[index]['hour'] = hour;

                this.allCondition[index]['min'] = parseInt(parseInt(this.allCondition[index].list) % (60));
              }else{
                this.allCondition[index]['day'] = 0;

                this.allCondition[index]['hour'] = 0;

                this.allCondition[index]['min'] = 0;
              }
          } else if("number" == allObj.customType){
            this.allCondition[index].list = this.allCondition[index].list == "" ? 1 : this.allCondition[index].list;
          } else if("checkbox" == allObj.customType || "cascade" == allObj.customType){
            this.allCondition[index].list = this.allCondition[index].list.split(',');
          }
        },
        // 数据回显  任意条件
        anySelectPop:function(index,selectObj){
          let value = selectObj.value;
          let anyObj = this.anyConditionList.find(item => item.customColName === value);

          if(anyObj.filterList) this.anyFilterMap.set(value, JSON.parse(JSON.stringify(anyObj.filterList)));
          this.anyFieldMap.set(value, anyObj.customType);
          if(anyObj.list) this.anyListMap.set(value, JSON.parse(JSON.stringify(this.doColseField(anyObj,this.anyCondition[index].list))));
          // 如果是处理人或抄送人，将服务组
          if(value == 'orderHandler' || value == 'copyEmpId'){
            if(anyObj.orderGroupList) this.anyListMap.set(value+'_group', JSON.parse(JSON.stringify(anyObj.orderGroupList)));
          }
          // 将选择的类型更新到数据上
          this.anyCondition[index].customType = anyObj.customType;
          this.anyCondition[index].customIsSystem = anyObj.customIsSystem;
          this.anyCondition[index].customColSource = anyObj.customColSource;
          // this.$forceUpdate();
          if("checkbox" == anyObj.customType || "cascade" == anyObj.customType){
            this.anyCondition[index].list = this.anyCondition[index].list.split(',');
          }
          
        },
        // 所有条件 下拉框展开收缩事件
        allOpenChange:function(index,flag){
          if(!flag){ //收缩
            if(this.allCondition[index].list.length == 0){
              this.allCondition[index].list = "";
            }
          }
        },
        // 任何条件 下拉框展开收缩事件
        anyOpenChange:function(index,flag){
          if(!flag){ //收缩
            if(this.anyCondition[index].list.length == 0){
              this.anyCondition[index].list = "";
            }
          }
        },
        // 执行条件 下拉框展开收缩事件
        executeOpenChange:function(index,flag){
          if(!flag){ //收缩
            if(this.executeCondition[index].list.length == 0){
              this.executeCondition[index].list = "";
            }
          }
        },
        // 时长 天时分数据变化回调函数
        durationDataChange:function(index){
          if(!this.allCondition[index].day || this.allCondition[index].day < 0){
            this.allCondition[index].day = 0;
          }
          if(!this.allCondition[index].hour || this.allCondition[index].hour < 0){
            this.allCondition[index].hour = 0;
          }
          if(!this.allCondition[index].min || this.allCondition[index].min < 0){
            this.allCondition[index].min = 0;
          }
         this.allCondition[index].list = parseInt(this.allCondition[index].day * 24 * 60) + parseInt(this.allCondition[index].hour * 60) + parseInt(this.allCondition[index].min);
        //  this.$forceUpdate();
        },
        // 时间日期控件少8小时
        changeDate:function(val){
          let dateee = new Date(val).toJSON();
          let date = new Date((new Date(dateee)).getTime()+8*3600*1000).toISOString().replace(/T/g,' ').replace(/\.[\d]{3}Z/,'');
          return date;
        },
        filterSelect:function(index,val,type){
          if(val){
            if('all' == type){
              this.allCondition[index].filterList[0] = JSON.parse(JSON.stringify(val));
            }else if('any' == type){
              this.anyCondition[index].filterList[0] = JSON.parse(JSON.stringify(val));
            }
          }

        },
        // 处理禁用字段
        doColseField:function(obj,value){
          if(obj.customIsSystem == '1' && ("select" == obj.customType || "radio" == obj.customType)){
               obj.list = obj.list.filter(option => option.isClose != '0' || option.id == value);
          }
          return obj.list;
        },
      },
      created(){

      },
      watch:{
          showPop:function() {
            this.model=this.showPop;
          },
          triggerId:function(){
            if(this.triggerId != "-1"){
              this.id = this.triggerId;
              if(this.id){
                this.title = "编辑触发器";
              }else{
                this.title = "添加触发器";
              }
              this.init();
            }
          }

        }
    }
</script>

<style scoped>
.condition-style{
    min-height:100px;
    background-color:#f3f3f3;
    padding: 10px;
    border: 1px solid #ebebeb;
    margin: 10px;
}
.input_single{
  margin-top:10px;
  margin-left:10px;
  margin-right:10px;
  display:flex;
}
.input_single .ivu-input-wrapper{
  width: 93%;
  margin-left:10px;
}
.font_style_set{
    width: 5%;
    text-align: end;
}
.condition-select-style{
    display:flex;
    margin: 10px;
    align-items: center;
    justify-content: space-around;
}

.contain-style{
  min-height: 230px;
  max-height: 450px;
  overflow: auto !important;
}
.contain-style::-webkit-scrollbar {
    height: 4px;
    width: 4px;
  }
  .contain-style::-webkit-scrollbar-thumb {
    background-color: #2db7f5;
  }


/*执行动作，回复下的样式*/
  .replay-style{
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 10px;
}
/*所有条件中 带时长的样式*/
.duration-style{
  display: flex;
    align-items: center;
    width: 35%;
    justify-content: center;
}
.ivu-select-multiple{
    max-height:32px;
}
</style>
<style>
  .ivu-message{
    z-index: 999999999 !important;
  }
 .condition-style .ivu-select-default.ivu-select-multiple .ivu-select-selection {
   min-height: 30px !important;
 }
 .condition-style .ivu-select-default.ivu-select-multiple .ivu-select-selection> div {
   height: 30px;
 }
.condition-style .ivu-select-multiple .ivu-tag{
   height: 25px!important;
   line-height: 25px!important;
 }
.condition-style textarea.ivu-input{
    margin-bottom: 0px !important;
  }
.condition-style .el-cascader .el-input .el-input__inner {
    max-height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/systemSetup/worknote/FlowTriggerPop.vue